module.exports = __webpack_public_path__ + "img/progressbar-light.a8568564.png";